import Toaster from './Toaster'

export default Toaster

export { toast } from './Toaster'
